import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { DescriptionPositions, DescriptionAlign, } from "./constants";
const { color, text, size } = ids || {};
const getContainerPosition = (position, align) => {
    switch (position) {
        case DescriptionPositions.down:
            return css `
        top: calc(100% + ${size.general.ids_size_general_12x});
        ${align === DescriptionAlign.left
                ? `left: -${size.general.ids_size_general_12x};`
                : align === DescriptionAlign.right
                    ? `right: -${size.general.ids_size_general_12x};`
                    : `left: 50%;
          transform: translate(-50%);`}
      `;
        case DescriptionPositions.top:
            return css `
        bottom: calc(100% + ${size.general.ids_size_general_12x});
        ${align === DescriptionAlign.left
                ? `left: -${size.general.ids_size_general_12x};`
                : align === DescriptionAlign.right
                    ? `right: -${size.general.ids_size_general_12x};`
                    : `left: 50%;
          transform: translate(-50%);`}
      `;
        case DescriptionPositions.left:
            return css `
        top: 50%;
        transform: translate(0, -50%);
        right: calc(100% + ${size.general.ids_size_general_12x});
      `;
        case DescriptionPositions.right:
            return css `
        top: 50%;
        transform: translate(0, -50%);
        left: calc(100% + ${size.general.ids_size_general_12x});
      `;
        default:
            return css `
        bottom: calc(100% + ${size.general.ids_size_general_12x});
        ${align === DescriptionAlign.left
                ? `left: -${size.general.ids_size_general_12x};`
                : align === DescriptionAlign.right
                    ? `right: -${size.general.ids_size_general_12x};`
                    : `left: 50%;
            transform: translate(-50%);`}
      `;
    }
};
const getArrowPosition = (position) => {
    switch (position) {
        case DescriptionPositions.down:
            return css `
        border-right: ${size.general.ids_size_general_6x} solid transparent;
        border-left: ${size.general.ids_size_general_6x} solid transparent;
        border-bottom-color: ${color.feedbacks.ids_color_feedback_neutral};
        top: -${size.general.ids_size_general_16x};
      `;
        case DescriptionPositions.top:
            return css `
        border-right: ${size.general.ids_size_general_6x} solid transparent;
        border-left: ${size.general.ids_size_general_6x} solid transparent;
        border-top-color: ${color.feedbacks.ids_color_feedback_neutral};
        bottom: -${size.general.ids_size_general_16x};
      `;
        case DescriptionPositions.left:
            return css `
        border-bottom: ${size.general.ids_size_general_6x} solid transparent;
        border-top: ${size.general.ids_size_general_6x} solid transparent;
        border-left-color: ${color.feedbacks.ids_color_feedback_neutral};
        right: -${size.general.ids_size_general_16x};
      `;
        case DescriptionPositions.right:
            return css `
        border-bottom: ${size.general.ids_size_general_6x} solid transparent;
        border-top: ${size.general.ids_size_general_6x} solid transparent;
        border-right-color: ${color.feedbacks.ids_color_feedback_neutral};
        left: -${size.general.ids_size_general_16x};
      `;
        default:
            return css `
        border-right: ${size.general.ids_size_general_6x} solid transparent;
        border-left: ${size.general.ids_size_general_6x} solid transparent;
        border-top-color: ${color.feedbacks.ids_color_feedback_neutral};
        bottom: -${size.general.ids_size_general_16x};
      `;
    }
};
const getArrowAlign = (align, position) => {
    if (position === DescriptionPositions.top ||
        position === DescriptionPositions.down)
        switch (align) {
            case DescriptionAlign.left:
                return css `
          left: ${size.general.ids_size_general_18x};
        `;
            case DescriptionAlign.right:
                return css `
          right: ${size.general.ids_size_general_18x};
        `;
            case DescriptionAlign.middle:
                return css `
          left: 50%;
          transform: translate(-50%);
        `;
        }
    return css `
    top: 50%;
    transform: translate(0, -50%);
  `;
};
const checkIsVisible = (isVisible) => {
    if (isVisible) {
        return css `
      display: flex;
    `;
    }
    return css `
    display: none;
  `;
};
export const StyledDescriptionContainer = styled.div `
  position: absolute;
  width: max-content;
  ${({ position, align }) => getContainerPosition(position, align)}
  ${({ isVisible }) => checkIsVisible(isVisible)}
`;
export const StyledDescriptionBox = styled.div `
  position: relative;
  align-items: center;
  background-color: ${color.feedbacks.ids_color_feedback_neutral};
  border-radius: ${size.corner_radius.ids_size_cornerRadius_tooltip};
  color: ${color.contrast.ids_color_contrast_onDark};
  display: flex;
  font: ${text.label.ids_textStyle_label_small_regular};
  line-height: rem(17.5);
  max-width: calc(
    ${size.general.ids_size_general_112x} +
      ${size.general.ids_size_general_100x}
  );
  padding: ${size.general.ids_size_general_12x};
`;
export const StyledDescriptionArrow = styled.div `
  position: absolute;
  border: ${size.general.ids_size_general_8x} solid transparent;
  ${({ position }) => getArrowPosition(position)}
  ${({ align, position }) => getArrowAlign(align, position)}
`;
export const StyledDescription = styled.div `
  position: relative;
  width: fit-content;
`;
//# sourceMappingURL=Description.style.js.map